import axios from 'axios'
import store from '@state/store'

export const state = {
  cachedActions: null,
  selectedAction: null,
}

export const getters = {
  cachedActions(state) {
    return state.cachedActions
  },

  selectedAction(state) {
    return state.selectedAction
  },
}

export const mutations = {
  SET_CACHE(state, actions) {
    state.cachedActions = actions
  },

  SET_SELECTED(state, action) {
    state.selectedAction = action
  },
}

export const actions = {
  selectAction({ commit, state, rootState }, { action }) {
    commit('SET_SELECTED', action)
  },

  actionById({ commit, state, rootState }, { actionId }) {
    let action = state.cachedActions.filter(
      (action) => action.id === parseInt(actionId, 10)
    )[0]
    return Promise.resolve(action)
  },

  fetchActions({ commit, state, rootState }, { clearCache, userId }) {
    // 1. Check if we've already fetched and cachedActions the user.
    const cachedActions = state.cachedActions
    if (!clearCache && cachedActions) {
      return Promise.resolve(cachedActions)
    }

    // 2. Fetch the actions from the API and cache it in case
    // we need it again in the future.
    return axios
      .get('/api/services/app/action/GetAll?userId=' + userId)
      .then((response) => {
        const actions = response.data.items

        commit('SET_CACHE', actions)

        return actions
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          // commit('SET_CACHE', null)
        }
        return null
      })
  },

  updateAction({ commit, dispatch, state, rootState }, { action }) {
    return axios
      .put('/api/services/app/action/Update', action)
      .then((response) => {
        dispatch('fetchActions', {
          clearCache: true,
          userId: store.getters['auth/currentUserId'],
        })
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          // commit('SET_CACHE', null)
        }
        return null
      })
  },

  deleteAction({ commit, dispatch, state, rootState }, { id }) {
    return axios
      .delete('/api/services/app/action/Delete/?id=' + id + '&userId=' + '1')
      .then((response) => {
        dispatch('fetchActions', {
          clearCache: true,
          userId: store.getters['auth/currentUserId'],
        })
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          // commit('SET_CACHE', null)
        }
        return null
      })
  },
}
